// extracted by mini-css-extract-plugin
export default {"buttonGroup":"CopilotWorkspaceButton-module__buttonGroup--ZEfG8"};